import { ProductListPage, ProductWithSpecification, Pagination, Product } from "Models/Products/ProductListPage";
import { FacetFilter, Option } from "Models/FacetFilter/FacetFilter";
import * as $ from "jquery";
import Vue from 'vue';
import Component from "vue-class-component";
import ABaseComponent from "Components/Base/ABaseComponent";
import productList from "Store/productList/productList";
import { Prop, Watch } from "vue-property-decorator"
import { Client, PorterViewModel, GetPorterItemListViewModel, PorterItemViewModel, ProductViewModel, IPorterItemsSize, IPorter, PorterKey, CreatePorterItemCommandArguments, PorterItemsSize, ReplacePorterItemCommandArguments } from "Api/CoreApi";
import ApiProvider from "Api/ApiProvider";
import porterBuilder from "Store/porterbuilder/porterbuilder";
import porterItems from "Store/porterItems/porterItems";
import productVariantStore from "Store/productVariantStore/productVariantStore";
import { toUpper } from "lodash";
import { Specification } from "Models/Products/ProductListPage";


@Component({})
export class ProductListPorterSizeSelectComponent extends ABaseComponent {
    @Prop()
    products: ProductWithSpecification[];

    @Prop()
    porter: IPorter;

    @Prop()
    languageId: string;

    @Prop()
    itemToUpdate: string; 

    @Prop()
    itemVariantIdToUpdate: string;


    currentProductIndex = 0;
    currentProduct: ProductWithSpecification = null; 

    currentLongDescription: string = null;
    currentColor: string = null;
    currentBrandDescription: string = null;
    currentGroupDescription: string = null;
    currentBrandCode: string = null;
    currentQuality: string = null;
    currentProductId:string = null; 
    currentVariants: ProductViewModel[] = []; 
    currentSizes: ProductViewModel[] = [];
    currentSelectedSize: IPorterItemsSize = null;

    currentSubSizes:ProductViewModel[] =[];
    currentSelectedSubSize: IPorterItemsSize = null;

    @Watch('currentSelectedSize')
    onSelectedSizeChange() {
        this.currentSelectedSubSize = null; 
    }

    get isSubSizesDisabled() {
        return this.currentSubSizes.length === 0;
    }

    get isSaveButtonDisabled() {
        if (this.currentSelectedSize == null) return true;
        if (this.currentSelectedSize.itemNumber === "" && this.currentSelectedSubSize == null) return true;
        return this.HasAnySubsizes && this.currentSelectedSubSize == null; 
    }

    public isSizeDisabled(val: IPorterItemsSize) {
        let data = porterItems.state.porterItemsSelectedSizes[this.currentProduct.Product.Number];
        return (data != null && data.some(x => x.itemNumber === val.itemNumber)); 
    }


    public get productHasSubsizes(): boolean {
        let data = porterItems.state.porterItemsAvailableSizes[this.currentProduct.Product.Number] || [];
        return data.some(x => x.isSubSize); 
    }


    public get AvailableSubSizes(): IPorterItemsSize[] {
        if (this.currentSelectedSize == null) return [];
        let data = porterItems.state.porterItemsAvailableSizes[this.currentProduct.Product.Number];
        return data == null ? [] : data.filter(x => x.isSubSize && x.size === this.currentSelectedSize.size).sort((a, b) => a.subSizeSortingOrder - b.subSizeSortingOrder);
    }

    public uniqueSizes(porterList: IPorterItemsSize[], currentItem: IPorterItemsSize): IPorterItemsSize[] {
        let exists = porterList.find(x => x.size === currentItem.size);
        if (exists == null) {
            porterList.push(<IPorterItemsSize>{
                subSize: "",
                size: currentItem.size,
                itemNumber: currentItem.isSubSize ? "" : currentItem.itemNumber,
                isSubSize: false,
                sizeSortingOrder: currentItem.sizeSortingOrder,
                variantNumber: currentItem.isSubSize ? "" : currentItem.variantNumber
            });
        } else {
            exists.itemNumber = currentItem.isSubSize ? exists.itemNumber : currentItem.itemNumber;
            exists.variantNumber = currentItem.isSubSize ? exists.variantNumber : currentItem.variantNumber; 
        }
        return porterList;
    }

    public get AvailableSizes(): IPorterItemsSize[] {
        if (this.currentProduct == null) return [];
        let data = porterItems.state.porterItemsAvailableSizes[this.currentProduct.Product.Number];
        return data == null ? [] : data.reduce((x, y) => this.uniqueSizes(x, y), [] as IPorterItemsSize[]).sort((a, b) => a.sizeSortingOrder - b.sizeSortingOrder); 
    }

    public get HasAnySubsizes() {
        return this.AvailableSubSizes.length !== 0; 
    }



    @Watch("currentProduct")
    async updateProductInformation() {
        this.currentLongDescription = this.getSpecification(this.currentProduct, "LongDescription");
        this.currentColor = this.getSpecification(this.currentProduct, "ColorCode");
        this.currentBrandCode = this.getSpecification(this.currentProduct, "BrandCode");
        this.currentBrandDescription = this.getSpecification(this.currentProduct, "BrandDescription");
        this.currentGroupDescription = this.getSpecification(this.currentProduct, "ProductGroupDescription");
        this.currentQuality = this.getSpecification(this.currentProduct, "Quality");
        this.currentProductId = this.getSpecification(this.currentProduct, "ProductId");
    }

    mounted() {
        if (this.products.length > 0) this.currentProduct = this.products[0];
        this.setLoaded();
    }

    getSpecification(product: ProductWithSpecification, name: string): string {
        const target = product.Specifications.find(a => a.Key === name);
        if (target && target.Value !== "") {
            return target.Value;
        } else return null;
    }

    getSpecPathOrDefault(product: ProductWithSpecification, spec: string, path: string, defaultValue: string) {
        spec = this.getSpecification(product, spec);
        return spec ? path + spec : defaultValue;
    }

    onCancel() {
        this.$emit("resetmodify");
    }

   

    public get modifyMode() {
        return !(this.itemToUpdate === "" || this.itemToUpdate == null);
    }

    async onUpdate() {
        if (!this.modifyMode) return;

        let selectedItem = porterItems.state.porterItemsSelectedSizes[this.itemToUpdate].filter(x => x.variantNumber == this.itemVariantIdToUpdate)[0]; // what to do if there are two 
        if (!selectedItem) {
            alert("An error happend, please try again.");
            return;
        } 

        const itemNoToCreate = (this.currentSelectedSubSize && this.currentSelectedSubSize !== "default")
            ? this.currentSelectedSubSize.itemNumber
            : this.currentSelectedSize.itemNumber;

        const client = ApiProvider.getApiClient();

        this.setLoading();

        try {
            
            const args = new ReplacePorterItemCommandArguments({
                    porterKey: new PorterKey({
                        id: this.porter.id
                    }),
                    newItemNo: itemNoToCreate,
                    oldItemNo: selectedItem.itemNumber,
                    comment: ""
                });
            await client.replacePorterItem(args);
            await porterItems.dispatchGetPorterItems({ languageId: this.languageId, porterId: this.porter.id }); 
            this.resetVariables();
        } catch (e) {
            console.debug(e);
        } finally {
            this.setLoaded();
            this.$emit("resetmodify");
        }
    }

    resetVariables() {
        this.currentProductIndex = 0;
        this.currentProduct = null;
        this.currentLongDescription = null;
        this.currentColor = null;
        this.currentBrandDescription = null;
        this.currentGroupDescription = null;
        this.currentBrandCode = null;
        this.currentQuality = null;
        this.currentProductId = null;
        this.currentVariants = [];
        this.currentSizes = [];
        this.currentSelectedSize = null;
        this.currentSubSizes = [];
        this.currentSelectedSubSize = null;
    }

    async onClickNextSave() {
        if (this.modifyMode) return; 

        const itemNoToCreate = (this.currentSelectedSubSize)
            ? this.currentSelectedSubSize.itemNumber
            : this.currentSelectedSize.itemNumber;

        const client = ApiProvider.getApiClient();

        var keepLoading = false;

        this.setLoading();

        try {

            const args = new CreatePorterItemCommandArguments({
                    porterKey: new PorterKey({
                        id: this.porter.id
                    }),
                    itemNo: itemNoToCreate,
                    comment: ""
                });
                await client.createPorterItem(args);
            

            if (this.currentProductIndex + 1 >= this.products.length) {
                keepLoading = true;
                location.reload();
                return;
            }

            this.currentProductIndex += 1;
            this.currentProduct = this.products[this.currentProductIndex];
        } catch (e) {
            console.debug(e);
        } finally {
            // if we are redirecting back to the productpage keep loading, to avoid flickering.
            if (!keepLoading) {
                this.setLoaded();
            }
        }
    }
}
Vue.component("product-list-porter-size-select", ProductListPorterSizeSelectComponent)